import { render, staticRenderFns } from "./workandrestManage.vue?vue&type=template&id=20aab260&scoped=true"
import script from "./workandrestManage.vue?vue&type=script&lang=js"
export * from "./workandrestManage.vue?vue&type=script&lang=js"
import style0 from "./workandrestManage.vue?vue&type=style&index=0&id=20aab260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aab260",
  null
  
)

export default component.exports